import { Icon, Icons } from '@clientbase/clientbase-library'
import { Box, Tooltip, Typography } from '@mui/material'
import { Charges } from 'models/PaymentLink'
import moment from 'moment'

import { ButtonRounded } from 'components/button'
import Can from 'components/Can'
import Status, { StatusKeys } from 'components/Status'

import { formatMoney } from 'utils'

import { theme } from 'styles/theme'

import { ContainerIcon } from './ModalPaymentLinkReport.styles'

export function convertToRows(items: Charges[], actions: any) {
  const rows = items?.map((item: Charges) => {
    return {
      customer: item.customer.name,
      due_date: moment(item?.due_date).format('DD/MM/YYYY'),
      amount: formatMoney(Number(item?.amount)),
      status: (
        <Can permission="billings:show">
          <Status
            status={item.status as StatusKeys}
            dueDate={item.due_date}
            sx={{ fontSize: '12px' }}
          />
        </Can>
      ),
      action: (
        <Can permission="billings:show">
          <Tooltip
            arrow={true}
            placement="top"
            title={
              item.type === 'Billing'
                ? 'Detalhes cobrança'
                : 'Detalhes recorrência'
            }
          >
            <Box
              onClick={
                item.type === 'Billing'
                  ? () => actions.handleOpenChargeDetails(item.uuid)
                  : () => actions.handleOpenRecurrenceDetails(item.uuid)
              }
            >
              <ButtonRounded variant="transparent">
                <Icon
                  icon="settings"
                  sx={{ color: theme.palette.neutral[200] }}
                />
              </ButtonRounded>
            </Box>
          </Tooltip>
        </Can>
      )
    }
  })

  return rows
}

export function renderTitle(label: string, icon: Icons, iconColor?: string) {
  return (
    <Box alignItems="center" display="flex" gap={'8px'}>
      <ContainerIcon>
        <Icon icon={icon} colorSX={iconColor} />
      </ContainerIcon>
      <Box>
        <Typography variant="smLight">{label}</Typography>
      </Box>
      <hr />
    </Box>
  )
}
